// application
import { AxiosResponse } from 'axios';
import {
  AccountRecoveryResponse,
  UserResponse,
  UserTokenResponse
} from '@models/response';
import {
  AccountResetPasswordRequest,
  AccountRecoveryRequest
} from '@models/request';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IAccountApi {
  abstract accountRecoveryPasswordApi(
    request: AccountRecoveryRequest
  ): Promise<AxiosResponse<Result<AccountRecoveryResponse>>>;
  abstract accountResetPasswordApi(
    request: AccountResetPasswordRequest
  ): Promise<AxiosResponse<Result<UserResponse>>>;
  abstract getUserLoggedApi(): Promise<AxiosResponse<Result<UserResponse>>>;
  abstract getUserToken(
    userName: string
  ): Promise<AxiosResponse<Result<UserTokenResponse>>>;
}
